import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

import { AppDrawer } from '@layout/AppDrawer';
import { MainAppBar } from '@layout/MainAppBar';
import { drawerWidth, drawerBreakpoint } from '@root/app.config';
import { InformationBanner } from '@components/InformationBanner';

const useStyles = makeStyles((theme) => ({
  toolbar: theme.mixins.toolbar, // necessary for content to be below app bar
  content: {
    [theme.breakpoints.up(drawerBreakpoint)]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
    flex: '1 1 auto',
    maxWidth: '100%',
  },
}));

export const Layout = ({ children }) => {
  const classes = useStyles();
  return (
    <Box display="flex">
      <MainAppBar />
      <AppDrawer />
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <InformationBanner />
        {children}
      </main>
    </Box>
  );
};
